<ion-header>
  <ion-toolbar>

    <ion-title>{{'library.workoutSelect.title' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button class="closeBtn" (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-searchbar 
    [(ngModel)]="searchTerm" 
    (ionInput)="filterWorkouts()" 
    [placeholder]="'library.workoutSelect.searchPlaceholder' | translate"
    class="searchbar-margin">
  </ion-searchbar>

  <ion-grid class="gridlist-content list-content" *ngIf="filteredWorkoutPrograms && filteredWorkoutPrograms.length > 0">
    <ion-row class="tableListPanel">
      <ng-container>
        <ion-col size="12" class="gridlist-list" detail *ngFor="let program of filteredWorkoutPrograms">
          <div class="libraryContainer">
            <div class="left">
              <div class="workout-icon-circle" *ngIf="type === 'workout'" [class.split-type]="isSplitProgram(program)">
                <ion-icon [name]="isSplitProgram(program) ? 'body-outline' : 'barbell-outline'"></ion-icon>
              </div>
              <div class="workout-icon-circle cardio-type" *ngIf="type === 'cardio'">
                <ion-icon name="bicycle-outline"></ion-icon>
              </div>
              <div class="libraryContent">
                <h6>{{'general.title' | translate}}</h6>
                <p>
                  {{program.title}}
                </p>
              </div>
            </div>
            <div class="center" *ngIf="source === 'user'">
              <div class="right__one">
                <div class="libraryContent">
                  <h6>{{'general.startDate' | translate}}</h6>
                  <p class="text-center">
                    {{program.startDate | date}}
                  </p>
                </div>
                <div class="libraryContent">
                  <h6>{{'general.endDate' | translate}}</h6>
                  <p>
                    <span *ngIf="program.endDate">{{program.endDate | date}}</span>
                    <span *ngIf="!program.endDate">-</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="right">
              <!-- Cardio -->
              <div class="actions" stop-propagation *ngIf="source === 'user' && type === 'cardio'">
                <ion-button fill="clear" mat-icon-button [matMenuTriggerFor]="menu">
                  {{'tracking.track' | translate}}
                </ion-button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item *ngFor="let day of program.programs[0].days; let j = index;" (click)="selectWorkout(program, j)">
                    <span>{{day.title}}</span>
                  </button>
                </mat-menu>
              </div>
              <!-- Workouts -->
              <div class="actions" stop-propagation *ngIf="source === 'user' && type === 'workout'">
                <ion-button fill="clear" mat-icon-button [matMenuTriggerFor]="menu">
                  {{'tracking.track' | translate}}
                </ion-button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item *ngFor="let workout of program.workouts; let j = index;" (click)="selectWorkout(program, j)">
                    <span>{{workout.title || (('general.day' | translate) + ' ' + (j + 1))}}</span>
                  </button>
                </mat-menu>
              </div>
              <!-- Organization -->
              <div class="actions" stop-propagation *ngIf="source === 'organization' && type === 'workout'">
                <ion-button fill="clear" (click)="selectOrgWorkout(program)">
                  {{'general.select' | translate}}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>

  <div *ngIf="filteredWorkoutPrograms && filteredWorkoutPrograms.length === 0 && workoutPrograms && workoutPrograms.length > 0" class="no-results">
    <p>{{'library.workoutSelect.noWorkoutsMatch' | translate:{searchTerm: searchTerm} }}</p>
  </div>

  <div *ngIf="!workoutPrograms || workoutPrograms.length === 0" class="no-results">
    <p>{{'library.workoutSelect.noWorkoutsAvailable' | translate}}</p>
  </div>

</ion-content>
